export default {
    FILTER_PREFIX: 'filter',
};
